import { render, staticRenderFns } from "./orderApprovalBar.vue?vue&type=template&id=576a9b44&"
import script from "./orderApprovalBar.vue?vue&type=script&lang=js&"
export * from "./orderApprovalBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports